export default __webpack_public_path__ + "static/media/00.79acc553.jpg";